import React from 'react'
import {PropTypes} from 'prop-types'
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

// Bottom to call a "delete" function 
// ...props is used for Button component. Eg. to parse an "id" or other parameters
export const ButtonDelete = ({to = "#", icon, onClick = "", linkClass = "", buttonClass = "", id = "", ...props}, context) => {

    const buttonClassName = (buttonClass)?"snx-btn-action " +  buttonClass:"snx-btn-action";
    const deleteIcon = (icon)?icon:"delete";

    return (    
        <Link to={to} className={linkClass} {...props}>
            <Button id={id} onClick={onClick} className={buttonClassName}>
                <i className="material-icons snx-icon-link-red snx-icon md-18" >{deleteIcon}</i>
            </Button>
        </Link>
    )
}

ButtonDelete.contextTypes = {
    t: PropTypes.func
}

export default ButtonDelete;
